import { render, staticRenderFns } from "./LimitCert.vue?vue&type=template&id=4fb7f25c&"
import script from "./LimitCert.vue?vue&type=script&lang=ts&"
export * from "./LimitCert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports